import { useMemo } from 'react';
import { usePerpMarkets } from '../perpMarkets/usePerpMarkets';
import { useSpotMarkets } from '../spotMarkets/useSpotMarkets';
import { MarketId } from '@velocity-exchange/common';
export const useAllTradeableMarketIds = () => {
	const perpMarkets = usePerpMarkets();
	const spotMarkets = useSpotMarkets();

	const allMarketIds = [
		...perpMarkets.map((m) => MarketId.createPerpMarket(m.marketIndex)),
		...spotMarkets.map((m) => MarketId.createSpotMarket(m.marketIndex)),
	];

	return useMemo(() => allMarketIds, [allMarketIds.length]);
};
